// extracted by mini-css-extract-plugin
export default {"shapePreset":"ShapesPresetCarousel_shapePreset__EYhSq"};